import React from 'react';

const Error = () => {
  return <div style={{textAlign: "center", margin: "3rem"}}>This page does not exist.</div>;
};

export default Error;
